import React from 'react';

const KeamananDataInformasiDesa: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Seiring dengan masifnya inisiatif digitalisasi desa, isu <b>keamanan siber dan perlindungan data pribadi kependudukan</b> menjadi aspek yang sangat krusial namun kerap terabaikan. Portal web desa mengelola data vital warga yang rentan terhadap penyalahgunaan apabila tidak dilindungi dengan standar keamanan yang memadai.
      </p>

      <p className="mb-4">
        Dalam pengembangan aplikasi web <b>EcoQuest Village</b> berbasis PHP dan MySQL, pengembang wajib menerapkan prinsip <i>Security by Design</i> untuk melindungi integritas sistem dari serangan peretasan umum di internet.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Langkah Proteksi Esensial untuk Aplikasi Web Desa
      </h2>
      <ol className="list-decimal pl-6 mb-6 space-y-3">
        <li>
          <strong>Pencegahan SQL Injection:</strong> Selalu menggunakan <i>Prepared Statements</i> dan <i>Parameterized Queries</i> saat berinteraksi dengan database MySQL, menghindari penggabungan string query langsung dengan input pengguna.
        </li>
        <li>
          <strong>Sanitasi dan Sanitasi XSS (Cross-Site Scripting):</strong> Meng-escape seluruh data teks input pengguna menggunakan fungsi <code>htmlspecialchars()</code> sebelum ditampilkan kembali di halaman web.
        </li>
        <li>
          <strong>Proteksi Form CSRF (Cross-Site Request Forgery):</strong> Menambahkan token acak sekali pakai (CSRF token) pada setiap form pengiriman data admin CMS.
        </li>
        <li>
          <strong>Enkripsi Kata Sandi yang Kuat:</strong> Memanfaatkan algoritma hashing modern seperti <code>password_hash()</code> dengan algoritma Bcrypt atau Argon2.
        </li>
      </ol>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Menjaga Privasi Data Warga
      </h2>
      <p className="mb-4">
        Data kependudukan yang dipublikasikan untuk umum harus disajikan dalam bentuk agregat statistik (misalnya piramida usia atau grafik mata pencaharian), dan tidak boleh menampilkan Nomor Induk Kependudukan (NIK) atau alamat lengkap individu tanpa enkripsi.
      </p>

      <p className="mb-4">
        Membangun website publik desa yang aman bukan hanya soal kepatuhan teknis, melainkan bentuk tanggung jawab moral dalam menjaga kepercayaan dan privasi seluruh warga desa di era digital.
      </p>
    </div>
  );
};

export default KeamananDataInformasiDesa;
